"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = TraditionalvRothPageThree;
var _react = _interopRequireWildcard(require("react"));
var _formik = require("formik");
var _CollapseInfo = _interopRequireDefault(require("../Wizard/CollapseInfo"));
var _utils = require("../../middleware/utils");
var _DisclosureModal = _interopRequireDefault(require("../Wizard/DisclosureModal"));
var _CalculateRecommendation = require("./CalculateRecommendation");
var _RecommendationBullets = require("./RecommendationBullets");
var _CalculateRetirementTaxRate = _interopRequireDefault(require("./CalculateRetirementTaxRate"));
var _TraditionalvRothRefineModal = _interopRequireDefault(require("./TraditionalvRothRefineModal"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function TraditionalvRothPageThree(_ref) {
  var {
    apiData,
    snapshot,
    refinementHandleClose,
    fetchDataScienceResults,
    showRefineModal,
    disclosureHandleClose,
    showDisclosure
  } = _ref;
  var resp = apiData === null || apiData === void 0 ? void 0 : apiData.data;
  var [isRothRecommended, setIsRothRecommended] = (0, _react.useState)(true);
  // Pulling formik context from higher up, which gives us access to formik state
  var {
    values: {
      retAge,
      withdrawalAge,
      currentAge,
      preference,
      lastYearTaxRate,
      retTaxRate
    },
    values,
    setFieldValue
  } = (0, _formik.useFormikContext)();
  (0, _react.useEffect)(() => {
    setIsRothRecommended((0, _CalculateRecommendation.calculateRecommendation)(values));
  }, [values]);
  var closeAndResetRefinementModal = snapshot => {
    refinementHandleClose();
    for (var property in snapshot) {
      setFieldValue(property, snapshot[property], false);
    }
  };
  var id1 = 'rothPlan';
  var contentArray1 = [
  // Roth
  {
    label: "Before-tax balance at age ".concat(retAge),
    value: (0, _utils.numberToCurrencyString)((0, _utils.parseCurrencyString)(null, resp['Roth'][3])),
    id: 'rothBeforeTaxBalance'
  }, {
    label: "Taxes due at ".concat((0, _CalculateRetirementTaxRate.default)(lastYearTaxRate, retTaxRate), " %"),
    value: (0, _utils.numberToCurrencyString)((0, _utils.parseCurrencyString)(null, resp['Roth'][5])),
    id: 'rothTaxesDue'
  }, {
    label: 'Your contribution rate ',
    value: "".concat((resp['Roth'][0] * 100).toFixed(2), " %"),
    id: 'rothContributionRate',
    popoverText: contributionRatePopoverText,
    popoverId: 'rothContributionRateInfo'
  }, {
    label: 'Total contributions this year',
    value: (0, _utils.numberToCurrencyString)((0, _utils.parseCurrencyString)(null, resp['Roth'][1]) + resp['Roth'][2]),
    id: 'rothTotalContributions'
  }, {
    label: 'Your annual contributions',
    value: (0, _utils.numberToCurrencyString)((0, _utils.parseCurrencyString)(null, resp['Roth'][1])),
    id: 'rothAnnualContributions'
  }, {
    label: 'Employer annual contributions',
    value: (0, _utils.numberToCurrencyString)((0, _utils.parseCurrencyString)(null, resp['Roth'][2])),
    id: 'rothEmployeeAnnualContributions'
  }];
  var id2 = 'traditionalPlan';
  var contentArray2 = [
  // Traditional
  {
    label: "Before-tax balance at age ".concat(retAge),
    value: (0, _utils.numberToCurrencyString)((0, _utils.parseCurrencyString)(null, resp['Traditional'][3])),
    id: 'traditionalBeforeTaxBalance'
  }, {
    label: "Taxes due at ".concat((0, _CalculateRetirementTaxRate.default)(lastYearTaxRate, retTaxRate), " %"),
    value: (0, _utils.numberToCurrencyString)((0, _utils.parseCurrencyString)(null, resp['Traditional'][5])),
    id: 'traditionalTaxesDue'
  }, {
    label: 'Your contribution rate ',
    value: "".concat((resp['Traditional'][0] * 100).toFixed(2), " %"),
    id: 'traditionalContributionRate',
    popoverText: contributionRatePopoverText,
    popoverId: 'traditionalContributionRateInfo'
  }, {
    label: 'Total contributions this year',
    value: (0, _utils.numberToCurrencyString)((0, _utils.parseCurrencyString)(null, resp['Traditional'][1] + resp['Traditional'][2])),
    id: 'traditionalTotalContributions'
  }, {
    label: 'Your annual contributions',
    value: (0, _utils.numberToCurrencyString)((0, _utils.parseCurrencyString)(null, resp['Traditional'][1])),
    id: 'traditionalAnnualContributions'
  }, {
    label: 'Employer annual contributions',
    value: (0, _utils.numberToCurrencyString)((0, _utils.parseCurrencyString)(null, resp['Traditional'][2])),
    id: 'traditionalEmployerAnnualContributions'
  }];
  var rothLabel = "<strong>Roth (after-tax)</strong><br/>After-tax balance at age ".concat(withdrawalAge);
  var rothTotal = (0, _utils.numberToCurrencyString)(resp['Roth'][6]);
  var formattedRothTotal = /*#__PURE__*/_react.default.createElement("div", {
    className: "rothVTrad total-col"
  }, rothTotal);
  var RothComponent = /*#__PURE__*/_react.default.createElement(_CollapseInfo.default, {
    label: rothLabel,
    total: formattedRothTotal,
    contentArray: contentArray1,
    id: id1
  });
  var traditionalLabel = "<strong>Traditional (pre-tax) </strong><br/>After-tax balance at age ".concat(withdrawalAge);
  var traditionalTotal = (0, _utils.numberToCurrencyString)(resp['Traditional'][6]);
  var formattedTraditionalTotal = /*#__PURE__*/_react.default.createElement("div", {
    className: "rothVTrad total-col"
  }, traditionalTotal);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, (0, _RecommendationBullets.getRecommendationBullets)(isRothRecommended, withdrawalAge, currentAge, retTaxRate, preference), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("p", {
    className: "blank-spacer"
  }), isRothRecommended ? RothComponent : null, /*#__PURE__*/_react.default.createElement(_CollapseInfo.default, {
    label: traditionalLabel,
    total: formattedTraditionalTotal,
    contentArray: contentArray2,
    id: id2
  }), !isRothRecommended ? RothComponent : null, /*#__PURE__*/_react.default.createElement("p", {
    className: "blank-spacer"
  }), /*#__PURE__*/_react.default.createElement(_TraditionalvRothRefineModal.default, {
    show: showRefineModal,
    handleClose: closeAndResetRefinementModal,
    snapshot: snapshot,
    fetchDataScienceResults: fetchDataScienceResults
  }), /*#__PURE__*/_react.default.createElement(_DisclosureModal.default, {
    handleClose: disclosureHandleClose,
    show: showDisclosure,
    textArray: disclosureTextArray
  })));
}
var disclosureTextArray = ['This interactive calculator is a self-help tool and is not intended to provide financial advice or product recommendations. The results and explanations generated by this calculator are based upon, and will vary due to, your input and certain assumptions made by us. All projections are hypothetical in nature, do not reflect actual results, and are not guarantees of future results. MassMutual will assume no liability for the use of or reliance on this calculator. For a more accurate and detailed analysis specific to your circumstances, we encourage you to contact a qualified financial professional.', 'The information provided is not written or intended as specific tax or legal advice. MassMutual, its employees and representatives are not authorized to give tax or legal advice. Individuals are encouraged to seek advice from their own tax or legal counsel.', 'Insurance products issued by Massachusetts Mutual Life Insurance Company (MassMutual), 1295 State Street, Springfield, MA 01111-0001 and its subsidiaries C.M. Life Insurance Company and MML Bay State Life Insurance Company, 100 Bright Meadow Boulevard, Enfield, CT 06082.'];
var contributionRatePopoverText = /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, "Contribution rate is calculated such that your estimated take-home pay is approximately equal in both scenarios.");